import { axiosInstance } from '@/lib/axios'
import { CreateCompanyModel } from '@/app/models/createCompanyModel'
import { ServerModel } from '@/app/models/serverModel'
import { DatabaseModel } from '@/app/models/databaseModel'
import { RolePermissionModel } from '@/app/models/rolePermissionModel'

export interface CreateCompanyRequest extends CreateCompanyModel {}

export interface CreateCompanyResponse {
  id: string
  companyName: string
  uniqueIdentifier: string
}

export function createCompany(request: CreateCompanyRequest) {
  return axiosInstance.post<CreateCompanyResponse>(
    '/config-api/company/create',
    request,
  )
}

export function getServers(companyId?: string) {
  const url = companyId
    ? `/config-api/server?&companyId=${companyId}`
    : '/config-api/server'
  return axiosInstance.get<ServerModel[]>(url)
}

export function getDatabases(companyId?: string, serverId?: string) {
  let url = '/config-api/database/list'
  const params = new URLSearchParams()
  if (companyId) params.append('companyId', companyId)
  if (serverId) params.append('serverId', serverId)
  if (params.toString()) url += `?&${params.toString()}`
  return axiosInstance.get<DatabaseModel[]>(url)
}

export function getRoles() {
  return axiosInstance.get<RolePermissionModel[]>('/config-api/role')
}

